import { useCallback } from 'react';
import { backendClient } from '@/lib/api-client';
import type { HomeActivity } from './useHomeDashboard';
import { useHomePagedList } from './useHomePagedList';

export type HomeRecentUploadsResponse = {
  items: HomeActivity[];
  has_more: boolean;
};

const PAGE_SIZE = 50;

export function homeRecentUploadsRequest(timezone: string, offset: number, limit = PAGE_SIZE) {
  return {
    key: ['/home/recent-uploads', timezone, offset, limit] as const,
    params: {
      timezone,
      offset,
      limit,
    },
  };
}

export function useHomeRecentUploads({
  timezone,
  enabled = true,
}: {
  timezone: string;
  enabled?: boolean;
}) {
  const fetchPage = useCallback(
    async (offset: number) => {
      const request = homeRecentUploadsRequest(timezone, offset);
      const response = await backendClient.get<HomeRecentUploadsResponse>('/home/recent-uploads', {
        params: request.params,
      });
      return {
        items: response.data.items,
        has_more: response.data.has_more,
        nextCursor: offset + response.data.items.length,
      };
    },
    [timezone],
  );

  return useHomePagedList({
    enabled,
    swrKey: ['/home/recent-uploads', timezone],
    initialCursor: 0,
    fetchPage,
    loadMoreErrorMessage: "Couldn't load more uploads.",
  });
}
